export default __webpack_public_path__ + "static/197-23433ade9c0e30bd78a46c04d8fc097b.jpg";